import React, { useState } from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useModal } from '../../../hooks/useModal';
import { gtmFunctions } from '../../../constants/analytics/GTM';
import { checkOnGoToShopBtn } from '../../../utils/helpers';
import useStateControls from '../../../hooks/useStateControls';
import { useTranslation } from '../../../translations';

const Buttons = React.forwardRef(function Buttons(
  { buttons, selfClose, nextModalData, callbacks, changeState, close, isGray, title = '' },
  ref,
) {
  const { addModal, closeModal, id } = useModal();
  const [isDisabled, setIsDisabled] = useState(false);
  const { setState } = useStateControls();
  const { t } = useTranslation();

  const nextModal = () => {
    closeModal({ type: 'all' });
  };

  const _close = () => {
    close?.();

    selfClose ? closeModal({ id }) : closeModal({ type: 'all' });

    if (nextModalData) {
      const { type, props } = nextModalData;
      addModal(type, props ?? {});
    }

    setIsDisabled(true);
  };

  const toConverter = () => {
    closeModal({ type: 'all' });
    addModal({ type: 'converterModal', props: { callbacks } });
  };

  return (
    <div className={classNames('w-modal__buttons', { 'w-modal__buttons_gray': isGray })}>
      {buttons &&
        buttons.map((item, id) => (
          <CustomButton
            key={`CustomButton-${id}`}
            {...item.attr}
            onClick={() => {
              if (isDisabled) return;
              if (item?.goConverter) toConverter();
              if (item?.callback) callbacks[item.callback](item?.callbackOptions);
              if (item?.isClose) _close();
              if (item?.isNext) nextModal();
              if (changeState) setState(changeState);
              checkOnGoToShopBtn(item?.attr, title, t) && gtmFunctions.GTMToShopAfterQuest(title);
            }}
          />
        ))}
    </div>
  );
});
export default Buttons;
Buttons.propTypes = {};
